exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header .close {\r\n\tdisplay: none;\r\n}\r\n\r\nlabel {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/detail-presence/detail-presence.component.css
// module id = 332
// module chunks = 0